import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Currency } from '../../../shared/models/currency-list';

@Component({
  selector: 'app-currency-icon',
  templateUrl: './currency-icon.component.html',
  styleUrls: ['./currency-icon.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CurrencyIconComponent implements OnChanges {

  @Input() currency;
  currencies = Currency;
  symbolObj;
  constructor() { }

  ngOnChanges(change: SimpleChanges): void {
    if (change && change.currency.currentValue && change.currency.currentValue) {
      this.symbolObj = this.currencies.find((item) => item.currency === this.currency?.toUpperCase());
    }
  }

}
